<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="tooltip">
					
				</div>
				<!--
				<full-calendar id="fullCalendar"
					v-bind="calendarOptions"
					:events="masTasks"
					contentHeight="auto"
					ref="fullCalendar"
					@select="onSelect"
				/>
				-->
				<FullCalendar id="fullCalendar" ref="fullCalendar"
					v-bind="calendarOptions"
					contentHeight="auto"
					allDaySlot="true"
					allDayClassNames="hehe"
					nowIndicator="true"
					:events="masTasks"
					@eventClick="taskClick"
					@eventMouseEnter="taskHover"
					:defaultView="strCalendarView"
					:eventTimeFormat="eventTimeFormat"
					:custom-buttons="customButtons"
					
					
					
				/>
				
			</div>
		</div>
	</div>
</template>

<!-- <script src="https://cdn.jsdelivr.net/npm/vue-tippy/dist/vue-tippy.min.js"></script> -->
<script src="https://unpkg.com/popper.js/dist/umd/popper.min.js"></script>
<script src="https://unpkg.com/tooltip.js/dist/umd/tooltip.min.js"></script>


<script>
import swal from 'sweetalert2';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import ruLocale from '@fullcalendar/core/locales/ru';
// import { Tooltip } from 'element-ui';
import { Tooltip } from "bootstrap";
// import { BPopover } from 'bootstrap-vue'
// import { popper } from 'www/node_modules/popper.js/dist/popper.min.js';


const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();
export default {
	components: {
		FullCalendar,
		// BPopover,
		Tooltip,
		// popper,
	},
	props: {
		masTasks: Array,
		strCalendarView: {
			type: String,
			default: 'dayGridMonth' // ['dayGridMonth' || 'timeGridDay' || 'timeGridWeek']
		},
		// eventRender: Object,
		// strCalendarType: {
		// 	type: String,
		// 	default: 'commonCalendar',
		// 	// default: 'lawCalendar'
		// }
	},
	data() {
		return {
			calendarOptions: {
				plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
				locale: ruLocale,
				theme: true,
				//initialView: this.strCalendarView,
				//defaultView: this.strCalendarView,
				header: {
					left: 'title',
					right: 'prev,next,today'
				},
				views: {
					month: {
						titleFormat: {
							month: 'long',
							year: 'numeric'
						}
					},
					week: {
						titleFormat: {
							day: '2-digit',
							month: 'long',
							year: 'numeric'
						}
					},
					day: {
						titleFormat: {
							day: '2-digit',
							month: 'long',
							year: 'numeric'
						}
					}
				},
				defaultDate: today,
				selectable: true,
				selectHelper: true,
				editable: false,
				eventLimit: true, // allow "more" link when too many events
				// eventRender: function(task) {
				// 	var tooltip = new Tooltip(task.el, {
				// 		title: task.event.extendedProps.task_data['agent_fio'],
				// 		placement: 'top',
				// 		trigger: 'hover',
				// 		container: 'body'
				// 	});
				// },
				// eventRender: function(event, element){
				// element.popover({
				// 	animation:true,
				// 	delay: 300,
				// 	content: '<b>Inicio</b>:'+event.start+"<b>Fin</b>:"+event.end,
				// 	trigger: 'hover'
				// });
				// },
				
			},
			
			eventTimeFormat: {
				hour: '2-digit',
				minute: '2-digit',
				hour12: false
			},
			customButtons: {
				prev: { // this overrides the prev button
					text: "PREV", 
					click: () => {           
						let calendarApi = this.$refs.fullCalendar.getApi();
						calendarApi.prev();
						this.$emit('prev',calendarApi.getDate());
					}
				},
				next: { // this overrides the next button
					text: "NEXT",
					click: () => {
						let calendarApi = this.$refs.fullCalendar.getApi();
						calendarApi.next();
						this.$emit('next',calendarApi.getDate());
					}
				}
			}
		};
	},
	watch: {
		
		strCalendarView: {
			immediate: true,
			deep: true,
			handler(newValue, oldValue) {
				if(typeof this.$refs.fullCalendar !='undefined'){
					this.$refs.fullCalendar.getApi().changeView(newValue);
				}
			}
		}
		
	},
	computed:{
		
	},
	methods: {
		strDefaultView(){
			if(this.strCalendarView == 'day'){
				return 'timeGridDay';
			} else if(this.strCalendarView == 'week'){
				return 'timeGridWeek';
			}
			return 'dayGridMonth';
		},		
		async onSelect({ start, end }) {
			// on select we show the Sweet Alert modal with an input
			let result = await swal({
				title: 'Create an Event',
				html:
					'<div class="form-group">' +
					'<input class="form-control" placeholder="Event Title" id="input-field">' +
					'</div>',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success',
				cancelButtonClass: 'btn btn-danger',
				buttonsStyling: false
			});
			if (result) {
				let eventData;
				let eventTitle = document.getElementById('input-field').value;
				if (eventTitle) {
					eventData = {
						title: eventTitle,
						start: start,
						end: end,
						className: 'event-default',	
						allDay: true,	
						// customHtml: 'this is <strong>really cool</strong>'
					};
					this.events.push(eventData)
				}
			}
		},
		taskClick(task){
			console.log(task.event);
			console.log(task.event.extendedProps);
		},
		taskHover(task){
			// оставили до лучших времен 

			// console.log("task id: " + task.event.id + ", agent_fio: " + task.event.extendedProps.task_data['agent_fio'] + ", STATUS: ");
			// var tooltip = new Tooltip(task.el, {
			// 	title: task.event.extendedProps.description,
			// 	placement: 'top',
			// 	trigger: 'hover',
			// 	container: 'body'
			// });
			// html:
			// 		'<div class="tooltip">' +
			// 		task.event.extendedProps.task_data['agent_fio'] +	
			// 		'</div>',;
			
			
		},
		
		// eventRender(task) {
		// 	var tooltip = new Tooltip(task.el, {
		// 		title: task.event.extendedProps.task_data['agent_fio'],
		// 		placement: 'top',
		// 		trigger: 'hover',
		// 		container: 'body'
		// 	});
		// },	
		
	}
};
</script>
<style>
	#fullCalendar {
		min-height: 400px;
	}
	#fullCalendar .fc-toolbar.fc-header-toolbar{height: 40px;}

	/* #fullCalendar .fc-time-grid .fc-event {inset: auto !important;} */

	.el-loading-spinner .path {
		stroke: #66615b !important;
	}

/* .tooltip {
	position: absolute;
	width: 320px;
	height: 500px;
	background-color: aquamarine;
} */
	
</style>

